import React from 'react';
import Navigation from './navigation';

export default function Header() {
  return (
    <header>
      <Navigation />
    </header>
  );
}



// WEBPACK FOOTER //
// ./src/components/header.js